import CustomProvider from './CustomProvider';

// export types
export type { CustomProviderProps } from '@/internals/Provider/CustomContext';

// export components
export { CustomProvider };
export default CustomProvider;
